import { render, staticRenderFns } from "./PYQPapers.vue?vue&type=template&id=1110db69&scoped=true&"
import script from "./PYQPapers.vue?vue&type=script&lang=js&"
export * from "./PYQPapers.vue?vue&type=script&lang=js&"
import style0 from "./PYQPapers.vue?vue&type=style&index=0&id=1110db69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1110db69",
  null
  
)

export default component.exports